<template>
  <div v-if="isAuthenticated" id="app">
    <Header></Header>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/Header'

import authentication from './auth'

export default {
  computed: {
    isAuthenticated () {
      return authentication.isAuthenticated()
    }
  },
  components: {
    Header
  }
}
</script>

<style lang="sass">
@import 'sass/all'
@import "../node_modules/leaflet/dist/leaflet.css"
</style>



// WEBPACK FOOTER //
// src/App.vue